
import React from "react";

const SectionHeader = ({ text,headingColor='text-[var(--color-neutral-10)]' }) => {
  return (
    <div className={`flex justify-between items-center ${headingColor}`}>
      <h4 className='font-semibold'>{text}</h4>
    </div>
  );
};
export { SectionHeader };